import React from "react";

export default function FileUpload() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 14H24.5C24.9832 14 25.375 14.3918 25.375 14.875V21.875C25.375 22.3582 24.9832 22.75 24.5 22.75H3.5C3.01678 22.75 2.625 22.3582 2.625 21.875V14.875C2.625 14.3918 3.01678 14 3.5 14Z"
        fill="#502D2D"
      />
      <path
        d="M3.5 14.875H8.75C9.23325 14.875 9.625 14.4832 9.625 14C9.625 13.5168 9.23325 13.125 8.75 13.125H3.5C2.77513 13.125 2.26256 13.6376 2.26256 13.6376C1.75 14.1501 1.75 14.875 1.75 14.875V21.875C1.75 22.5999 2.26256 23.1124 2.26256 23.1124C2.77513 23.625 3.5 23.625 3.5 23.625H24.5C25.2249 23.625 25.7374 23.1124 25.7374 23.1124C26.25 22.5999 26.25 21.875 26.25 21.875V14.875C26.25 14.1501 25.7374 13.6376 25.7374 13.6376C25.2249 13.125 24.5 13.125 24.5 13.125H19.25C18.7668 13.125 18.375 13.5168 18.375 14C18.375 14.4832 18.7668 14.875 19.25 14.875H24.5V21.875H3.5V14.875Z"
        fill="url(#paint0_linear_268_653)"
      />
      <path
        d="M14.875 14V2.625C14.875 2.14175 14.4832 1.75 14 1.75C13.5168 1.75 13.125 2.14175 13.125 2.625V14C13.125 14.4832 13.5168 14.875 14 14.875C14.4832 14.875 14.875 14.4832 14.875 14Z"
        fill="url(#paint1_linear_268_653)"
      />
      <path
        d="M18.6308 8.49327L18.6313 8.49372C18.7954 8.65781 19.0179 8.75 19.25 8.75C19.4821 8.75 19.7046 8.65781 19.8687 8.49372C20.0328 8.32962 20.125 8.10706 20.125 7.875C20.125 7.64294 20.0328 7.42038 19.8687 7.25628L14.6187 2.00628C14.4546 1.84219 14.2321 1.75 14 1.75C13.7679 1.75 13.5454 1.84219 13.3813 2.00628L8.13161 7.25595L8.13128 7.25628C7.96719 7.42038 7.875 7.64294 7.875 7.875C7.875 7.88902 7.87534 7.90303 7.87601 7.91703C7.88646 8.13431 7.97747 8.3399 8.13128 8.49372C8.29538 8.65781 8.51794 8.75 8.75 8.75C8.98206 8.75 9.20462 8.65781 9.36872 8.49372L9.36905 8.49339L14 3.86244L18.6308 8.49327Z"
        fill="url(#paint2_linear_268_653)"
      />
      <path
        d="M21.875 18.375C21.875 19.0998 21.2873 19.6875 20.5625 19.6875C19.8377 19.6875 19.25 19.0998 19.25 18.375C19.25 17.6502 19.8377 17.0625 20.5625 17.0625C21.2873 17.0625 21.875 17.6502 21.875 18.375Z"
        fill="url(#paint3_linear_268_653)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_268_653"
          x1="3.45604"
          y1="21.9676"
          x2="19.7197"
          y2="14.2444"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED1C24" />
          <stop offset="0.26" stopColor="#EC281E" />
          <stop offset="0.73" stopColor="#EC480E" />
          <stop offset="1" stopColor="#EC5E04" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_268_653"
          x1="13.2469"
          y1="12.8032"
          x2="14.6695"
          y2="12.7646"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED1C24" />
          <stop offset="0.26" stopColor="#EC281E" />
          <stop offset="0.73" stopColor="#EC480E" />
          <stop offset="1" stopColor="#EC5E04" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_268_653"
          x1="8.72802"
          y1="7.64506"
          x2="17.5718"
          y2="4.49531"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED1C24" />
          <stop offset="0.26" stopColor="#EC281E" />
          <stop offset="0.73" stopColor="#EC480E" />
          <stop offset="1" stopColor="#EC5E04" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_268_653"
          x1="19.4328"
          y1="19.2731"
          x2="21.4833"
          y2="18.8558"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED1C24" />
          <stop offset="0.26" stopColor="#EC281E" />
          <stop offset="0.73" stopColor="#EC480E" />
          <stop offset="1" stopColor="#EC5E04" />
        </linearGradient>
      </defs>
    </svg>
  );
}
